import { EventEmitter, OnInit } from '@angular/core';
import { Task } from '@ml/tasks/types/classes';
import { OrderLocation } from '@ml/orders/types/classes';
import { TaskLocationStatus } from '@ml/tasks/types/enums/task-location-status.enum';
import { User } from '@ml/core/types/classes';
import { UserRole } from '@ml/core/types/enums';
var OrderLocationStatusComponent = /** @class */ (function () {
    function OrderLocationStatusComponent() {
        this.selectLocation = new EventEmitter();
        this.locationViewMode = 'task';
    }
    OrderLocationStatusComponent.prototype.ngOnInit = function () { };
    OrderLocationStatusComponent.prototype.onSelectField = function (task) {
        if (this.canSelectTask(task)) {
            var taskLocation = this.getLocation(task);
            this.selectLocation.emit(taskLocation);
        }
    };
    Object.defineProperty(OrderLocationStatusComponent.prototype, "parsedTasks", {
        get: function () {
            if (this.tasks.length === 0) {
                return [];
            }
            var locationViewMode = this.tasks[0].order.locationViewMode;
            this.locationViewMode = locationViewMode;
            if (locationViewMode === 'task') {
                return this.tasks;
            }
            else if (locationViewMode === 'service') {
                var services_1 = [];
                return this.tasks
                    .filter(function (task) {
                    if (task.service === null) {
                        return true;
                    }
                    if (services_1.includes(task.service.id)) {
                        return false;
                    }
                    services_1.push(task.service.id);
                    return true;
                })
                    .sort(function (a, b) {
                    return a.servicePosition > b.servicePosition ? 1 : -1;
                });
            }
            return this.tasks;
        },
        enumerable: true,
        configurable: true
    });
    OrderLocationStatusComponent.prototype.getCircleClasses = function (task) {
        var classes = this.getCurrentTaskClass(task) + " " + this.getStatusClass(task);
        if (this.canSelectTask(task)) {
            classes += ' cursor-pointer';
        }
        return classes;
    };
    OrderLocationStatusComponent.prototype.getCurrentTaskClass = function (task) {
        if (this.currentTask && this.currentTask.id === task.id) {
            return 'current-task';
        }
    };
    OrderLocationStatusComponent.prototype.canSelectTask = function (task) {
        if (this.user && this.user.role === UserRole.ADMIN) {
            return true;
        }
        if (this.currentTask && this.currentTask.id === task.id) {
            return true;
        }
        return (this.currentTask &&
            this.currentTask.service.id === task.service);
    };
    OrderLocationStatusComponent.prototype.getStatusClass = function (task) {
        var taskLocation = this.getLocation(task);
        switch (taskLocation.status) {
            case TaskLocationStatus.NOT_STARTED:
                return 'not-started';
            case TaskLocationStatus.IN_PROGRESS:
                return 'in-progress';
            case TaskLocationStatus.STOPPED:
                return 'stopped';
        }
    };
    OrderLocationStatusComponent.prototype.getLocation = function (task) {
        var _this = this;
        var locations = task.locations;
        return locations.find(function (location) {
            if (typeof location.orderLocation === 'number') {
                return location.orderLocation === _this.orderLocation.id;
            }
            return location.orderLocation.id === _this.orderLocation.id;
        });
    };
    return OrderLocationStatusComponent;
}());
export { OrderLocationStatusComponent };
